import * as React from "react";

function SvgBigQuery(props, ref) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 65 65" {...{ ...props, ref }}>
      <path
        d="M14.48 58.196L.558 34.082a4.163 4.163 0 010-4.164L14.48 5.805a4.163 4.163 0 013.6-2.082h27.857c1.48.007 2.845.8 3.585 2.082l13.92 24.113a4.163 4.163 0 010 4.164L49.52 58.196a4.163 4.163 0 01-3.6 2.082H18.07a4.167 4.167 0 01-3.593-2.082z"
        fill="#4386fa"
      />
      <path
        d="M40.697 24.235s3.87 9.283-1.406 14.545-14.883 1.894-14.883 1.894L43.95 60.27h1.984a4.163 4.163 0 003.6-2.082L58.75 42.23z"
        opacity={0.1}
      />
      <path
        d="M45.267 43.23L41 38.953a.67.67 0 00-.158-.12 11.63 11.63 0 10-2.032 2.037.67.67 0 00.113.15l4.277 4.277a.67.67 0 00.947 0l1.12-1.12a.67.67 0 000-.947zM31.64 40.464a8.75 8.75 0 118.749-8.749 8.75 8.75 0 01-8.749 8.749zm-5.593-9.216v3.616a6.426 6.426 0 002.338 2.375v-6.013zm4.375-2.998v9.772a6.45 6.45 0 002.338 0V28.25zm6.764 6.606v-2.142H34.85v4.5a6.43 6.43 0 002.338-2.368z"
        fill="#fff"
      />
    </svg>
  );
}

export default React.forwardRef(SvgBigQuery);
